import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import BiddingTableSC, { AdditionalTopSC /* EmptySC */ } from './loan-bidding-table.styled';
import { BodyText /*  SmallText */, SmallText } from '../../typography';
import BiddingItem from './bidding-item';
import dlt from '../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import useWindowSize from '../../../utils/screen-size';
import { BP_TABLET_MIN } from '../../../assets/styles/breakpoints';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import WishmakerModal from '../../ui/modal/modal';
import BidModal from './bid-modal';
import SmsVerification from '../../sms-verification';
import SuccessModal from '../../success-modal';
import { ROUTE_INVESTMENTS } from '../../../constants';
import WarningModal from '../../warning-modal';

const _BiddingTable = ({
  hasAdditionalTop,
  sendSms,
  biddings,
  bidSecondaryMarketOffer,
  getInvestorInvestmentDetail,
  history,
  match,
  acceptBiddingOffer,
  declineBiddingOffer,
}) => {
  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;

  const [additionalData, setAdditionalData] = useState({});
  const [isSmsModalOpened, setSmsModalOpened] = useState(false);
  const [isBidModalOpened, setIsBidModalOpened] = useState(false);
  const [isSmsCodeError, setIsSmsCodeError] = useState(false);
  const [isSuccessModalOpened, setSuccessModalOpened] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [offerDetail, setOfferDetail] = useState({});
  const [bidAmount, setBidAmount] = useState('');
  const [isWarnModalOpened, setWarnModalOpened] = useState(false);
  const [warnModalHeadline, setWarnModalHeadline] = useState('');

  /* Send sms */
  const onSmsSend = (smsType) => {
    if (smsType) {
      sendSms({ type: smsType });
    } else {
      switch (additionalData.type) {
        case 'sell':
          sendSms();

          break;
        case 'bid':
          sendSms(/* { type: 'bid-offer' } */);
          break;

        case 'cancel':
          sendSms(/* { type: 'bid-offer' } */);
          break;

        default:
          sendSms(/* { type: 'bid-offer' } */);
          break;
      }
    }
  };

  /* On cancel offer click */
  const onCancelClick = (event, offerData) => {
    event.stopPropagation();
    setAdditionalData({ biddingId: offerData.bidding_id, type: 'cancel' });
    onSmsSend('cancel-bid');
    setSmsModalOpened(true);
  };

  const onSellClick = (event, offerData) => {
    event.stopPropagation();
    setAdditionalData({ biddingId: offerData.bidding_id, type: 'sell' });
    onSmsSend('sell-bid');
    setSmsModalOpened(true);
  };

  const onBidClick = (event, offerData) => {
    event.stopPropagation();
    setOfferDetail(offerData);
    setIsBidModalOpened(true);
  };

  const onBidModalSubmit = (offerId, biddingId, bidAmount) => {
    setBidAmount(bidAmount);
    setIsBidModalOpened(false);
    setAdditionalData({ offerId: offerId, biddingId: biddingId, type: 'bid' });
    onSmsSend('make-bid');
    setSmsModalOpened(true);
  };

  /* After success modal close call refresh data */
  const onCloseSuccess = () => {
    setSuccessModalOpened(false);

    const onBadId = () => {
      history.push(ROUTE_INVESTMENTS);
    };

    getInvestorInvestmentDetail({
      id: match.params.id,
      onBadId,
    });
  };

  /* SMS Confirmation of cancel offer call */
  const onSmsModalSubmit = (smsModalData) => {
    const onBadSmsCode = () => {
      setIsSending(false);
      setIsSmsCodeError(true);
    };
    const onOfferError = (code) => {
      setIsSending(false);
      setSmsModalOpened(false);
      setWarnModalOpened(true);
      if (code === 'NOT_YOUR_TURN') {
        setWarnModalHeadline('investor_secondary_market_not_your_turn_error_headline');
      } else {
        setWarnModalHeadline('investor_secondary_market_offer_closed_error_headline');
      }
    };
    const onSuccess = () => {
      setIsSending(false);
      setSmsModalOpened(false);
      setSuccessModalOpened(true);
    };

    const onError = () => {
      setIsSending(false);
    };

    if (smsModalData.type === 'sell') {
      const onSellOffer = async () => {
        await acceptBiddingOffer({
          data: { sms_code: smsModalData.sms_code },
          bidding: smsModalData.biddingId,
          onSuccess,
          onBadSmsCode,
          onBiddingError: onOfferError,
          onError,
        });
        setIsSending(true);
      };
      onSellOffer();
    }
    if (smsModalData.type === 'bid') {
      const onBidOffer = async () => {
        await bidSecondaryMarketOffer({
          data: {
            sms_code: smsModalData.sms_code,
            value: Number(bidAmount.replace(/ /g, '').replace(/,/g, '.')),
          },
          offer: smsModalData.offerId,
          biddingId: smsModalData.biddingId,
          onSuccess,
          onBadSmsCode,
          onOfferError,
          onError,
        });
        setIsSending(true);
      };
      onBidOffer();
    }
    if (smsModalData.type === 'cancel') {
      const onCancelOffer = async () => {
        await declineBiddingOffer({
          data: { sms_code: smsModalData.sms_code },
          bidding: smsModalData.biddingId,
          onSuccess,
          onBadSmsCode,
          onBiddingError: onOfferError,
          onError,
        });
        setIsSending(true);
      };
      onCancelOffer();
    }
  };

  const onWarnModalClose = () => {
    setWarnModalOpened(false);
    const onBadId = () => {
      history.push(ROUTE_INVESTMENTS);
    };
    getInvestorInvestmentDetail({
      id: match.params.id,
      onBadId,
    });
  };

  return (
    <>
      <WishmakerModal
        isOpened={isSuccessModalOpened}
        onClose={() => onCloseSuccess()}
        className="special"
        withCross
      >
        <SuccessModal
          headlineText={
            additionalData.type === 'sell'
              ? 'investor_bidding_success_modal_sell'
              : additionalData.type === 'bid'
              ? 'investor_bidding_success_modal_bid'
              : 'investor_bidding_success_modal_cancel'
          }
        />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isWarnModalOpened}
        onClose={onWarnModalClose}
        className="special"
        withCross
      >
        <WarningModal headlineText={warnModalHeadline} />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isSmsModalOpened}
        onClose={() => setSmsModalOpened(false)}
        className="special"
        withCross
      >
        <SmsVerification
          onSubmit={(data) => onSmsModalSubmit(data)}
          additionalData={additionalData}
          isError={isSmsCodeError}
          isSending={isSending}
          onResend={() => onSmsSend()}
          onBadSms={() => setIsSmsCodeError(false)}
        />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isBidModalOpened}
        onClose={() => setIsBidModalOpened(false)}
        className="special"
        withCross
      >
        <BidModal
          offerDetail={offerDetail}
          onSubmit={(offerId, biddingId, bidAmount) =>
            onBidModalSubmit(offerId, biddingId, bidAmount)
          }
          type="sell"
        />
      </WishmakerModal>
      {hasAdditionalTop ? (
        <AdditionalTopSC>
          <BodyText className="bolder">
            <FormattedMessage
              id="investor_bidding_table_headline"
              defaultMessage={dlt['investor_bidding_table_headline']}
            />
          </BodyText>
          <div className="line-separator"></div>
        </AdditionalTopSC>
      ) : null}
      <BiddingTableSC>
        {isTablet ? null : (
          <thead>
            <tr>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_bidding_table_head_1_1"
                    defaultMessage={dlt['investor_bidding_table_head_1_1']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_bidding_table_head_2"
                    defaultMessage={dlt['investor_bidding_table_head_2']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_bidding_table_head_3_1"
                    defaultMessage={dlt['investor_bidding_table_head_3_1']}
                  />
                </SmallText>
              </th>
              <th>
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_bidding_table_head_4"
                    defaultMessage={dlt['investor_bidding_table_head_4']}
                  />
                </SmallText>
              </th>
              <th></th>
            </tr>
          </thead>
        )}

        <tbody>
          {biddings.map((item) => {
            return (
              <BiddingItem
                key={item.offer_id}
                buyerWmNumber={item.buyer_wm_number}
                amountForSale={Number(item.amount_for_sale)}
                buyerLastBid={Number(item.buyer_last_bid)}
                sellerLastBid={Number(item.seller_last_bid)}
                showButtons={item.show_buttons}
                status={item.status}
                timeRemaining={item.time_remaining}
                isTablet={isTablet}
                onCancelClick={(e) => onCancelClick(e, item)}
                onSellClick={(e) => onSellClick(e, item)}
                onBidClick={(e) => onBidClick(e, item)}
                lastBidder={item.last_bidder}
              />
            );
          })}
        </tbody>
      </BiddingTableSC>
    </>
  );
};

_BiddingTable.propTypes = {
  maxRows: PropTypes.number,
  hasPagination: PropTypes.bool,
  hasAdditionalTop: PropTypes.bool,
};

_BiddingTable.defaultProps = {
  maxRows: null,
  hasPagination: false,
  hasAdditionalTop: false,
};

const mapStateToProps = (state) => {
  return {
    offers: state.offers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      sendSms: ActionCreators.sendSms,
      getInvestorOffers: ActionCreators.getInvestorOffers,
      cancelOfferSell: ActionCreators.cancelOfferSell,
      bidSecondaryMarketOffer: ActionCreators.bidSecondaryMarketOffer,
      getInvestorInvestmentDetail: ActionCreators.getInvestorInvestmentDetail,
      acceptBiddingOffer: ActionCreators.acceptBiddingOffer,
      declineBiddingOffer: ActionCreators.declineBiddingOffer,
    },
    dispatch
  );
};

const BiddingTable = withRouter(connect(mapStateToProps, mapDispatchToProps)(_BiddingTable));

export default BiddingTable;
